import { Navigate } from 'react-router';

import { ANY_SPORT_SERIES_PLAY } from '@sorare/core/src/constants/__generated__/routes';

const SeriesPlayPage = () => {
  return <Navigate to={ANY_SPORT_SERIES_PLAY} replace />;
};
export default SeriesPlayPage;
